import { css } from '@/styled-system/css';

export const content = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  minWidth: '0',
  lg: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 'default',
  },
});

export const label = css({
  flexShrink: 0,
  color: 'inherit',
  fontSize: 'body-xs',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
});

export const message = css({
  flex: '1 1 auto',
  minWidth: '0',
});
